// extracted by mini-css-extract-plugin
module.exports = {"faq__hero":"FAQHero_faq__hero__0V4Im","faq__hero_title":"FAQHero_faq__hero_title__f8AD1"};